module["exports"] = [
  "stad",
  "land",
  "sås",
  "ås",
  "holm",
  "tuna",
  "sta",
  "berg",
  "löv",
  "borg",
  "mora",
  "hamn",
  "fors",
  "köping",
  "by",
  "hult",
  "torp",
  "fred",
  "vik"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/city_suffix.js
// module id = 1590
// module chunks = 0